import {
  Box,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import moment from "moment";
import React from "react";
import { useSelector } from "react-redux";

const style = {
  height: "44px",
  backgroundColor: "#E5F3FF",
  color: "#202020",
  fontWeight: "500",
  whiteSpace: "pre-line",
  lineHeight: 1.3,
};
const ExcelTable = (props) => {
  const { reportsData, toDate, fromDate, reportData1 } = props;
  const store = useSelector((store) => store);
  const { user } = store;
  const TableHeaderColumn = [
    {
      headerName: "Booked Transaction Details",
      colSpan: 13,
      field: "bookedTransactionDetails",
      xlCol: { dataType: "string", dataFormatter: null },
      headerSx: { textAlign: "left" },
      showFilter: true,
    },
  ];
  const TableTwoHeaderColumn = [
    {
      headerName: "KSTDC POS Transaction",
      colSpan: 13,
      field: "kstdcPosTransaction",
      xlCol: { dataType: "string", dataFormatter: null },
      headerSx: { textAlign: "left" },
      showFilter: true,
    },
  ];

  const TableHeaderColumnTwo = [
    {
      headerName: "Txn. Date",
      field: "TxnDate",
      xlCol: { dataType: "string", dataFormatter: null },
      headerSx: { textAlign: "left" },
      showFilter: true,
    },
    {
      headerName: "Time",
      field: "TxnTime",
      xlCol: { dataType: "string", dataFormatter: null },
      headerSx: { textAlign: "left" },
      showFilter: true,
    },
    {
      headerName: "OB Ref.",
      field: "OBRefno",
      xlCol: { dataType: "string", dataFormatter: null },
      headerSx: { textAlign: "left" },
      showFilter: true,
    },
    {
      headerName: "POS Txn. ID",
      field: "posTxnId",
      xlCol: { dataType: "string", dataFormatter: null },
      headerSx: { textAlign: "left" },
      showFilter: true,
    },
    {
      headerName: "Amount",
      field: "Amount",
      xlCol: { dataType: "number", dataFormatter: null },
      headerSx: { textAlign: "right" },
      showFilter: true,
    },
    {
      headerName: "PNR No.",
      field: "PNRNo",
      xlCol: { dataType: "string", dataFormatter: null },
      headerSx: { textAlign: "left" },
      showFilter: true,
    },
    {
      headerName: "Ticket No.",
      field: "TktNo",
      xlCol: { dataType: "number", dataFormatter: null },
      headerSx: { textAlign: "right" },
      showFilter: true,
    },
    {
      headerName: "DOJ",
      field: "doj",
      xlCol: { dataType: "string", dataFormatter: null },
      headerSx: { textAlign: "left" },
      showFilter: true,
    },
    {
      headerName: "User",
      field: "user",
      xlCol: { dataType: "string", dataFormatter: null },
      headerSx: { textAlign: "left" },
      showFilter: true,
    },
    {
      headerName: "CounterCode",
      field: "CounterCode",
      xlCol: { dataType: "string", dataFormatter: null },
      headerSx: { textAlign: "left" },
      showFilter: true,
    },
    {
      headerName: "Station",
      field: "station",
      xlCol: { dataType: "string", dataFormatter: null },
      headerSx: { textAlign: "left" },
      showFilter: true,
    },
    {
      headerName: "POS Device ID",
      field: "posDeviceId",
      xlCol: { dataType: "string", dataFormatter: null },
      headerSx: { textAlign: "left" },
      showFilter: true,
    },
    {
      headerName: "Txn",
      field: "ModificationTypeName",
      exportHead: "Txn",
      xlCol: { dataType: "string", dataFormatter: null },
      headerSx: { textAlign: "left" },
      showFilter: true,
    },
  ];
  const InsideRowContent = ({ item, index, fontVal }) => {
    return (
      <>
        {item.isDataRow ? (
          <TableRow>
            <>
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{
                  background: "F5FAFE",
                  fontSize: fontVal,
                  fontWeight: "500",
                  textAlign: "left",
                }}
              >
                {item.TxnDate}
              </TableCell>
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{
                  background: "F5FAFE",
                  fontSize: fontVal,
                  fontWeight: "500",
                  textAlign: "left",
                }}
              >
                {item.TxnTime}
              </TableCell>
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{
                  background: "F5FAFE",
                  fontSize: fontVal,
                  fontWeight: "500",
                  textAlign: "left",
                }}
              >
                {item.OBRefno}
              </TableCell>
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{
                  background: "F5FAFE",
                  fontSize: fontVal,
                  fontWeight: "500",
                  textAlign: "left",
                }}
              >
                {item.PGTransactionID}
              </TableCell>
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{
                  background: "F5FAFE",
                  fontSize: fontVal,
                  fontWeight: "500",
                  textAlign: "right",
                }}
              >
                {item.Amount}
              </TableCell>
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{
                  background: "F5FAFE",
                  fontSize: fontVal,
                  fontWeight: "500",
                  textAlign: "left",
                }}
              >
                {item.PNRNo}
              </TableCell>
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{
                  background: "F5FAFE",
                  fontSize: fontVal,
                  fontWeight: "500",
                  textAlign: "right",
                }}
              >
                {item.TktNo}
              </TableCell>
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{
                  background: "F5FAFE",
                  fontSize: fontVal,
                  fontWeight: "500",
                  textAlign: "left",
                }}
              >
                {item.JourneyDate}
              </TableCell>
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{
                  background: "F5FAFE",
                  fontSize: fontVal,
                  fontWeight: "500",
                  textAlign: "left",
                }}
              >
                {item.User}
              </TableCell>
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{
                  background: "F5FAFE",
                  fontSize: fontVal,
                  fontWeight: "500",
                  textAlign: "left",
                }}
              >
                {item.CounterCode}
              </TableCell>
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{
                  background: "F5FAFE",
                  fontSize: fontVal,
                  fontWeight: "500",
                  textAlign: "left",
                }}
              >
                {item.BusStation}
              </TableCell>
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{
                  background: "F5FAFE",
                  fontSize: fontVal,
                  fontWeight: "500",
                  textAlign: "left",
                }}
              >
                {item.POSDeviceID}
              </TableCell>
                  <TableCell
                className="reportTD"
                colSpan={1}
                style={{
                  background: "F5FAFE",
                  fontSize: fontVal,
                  fontWeight: "500",
                  textAlign: "left",
                }}
              >
                {item.ModificationTypeName}
              </TableCell>
            </>
          </TableRow>
        ) : (
          item.isTotalRow && (
            <TableRow>
              <>
                <TableCell
                  className="reportTD"
                  colSpan={3}
                  style={{
                    background: "F5FAFE",
                    fontSize: fontVal,
                    fontWeight: "600",
                    textAlign: "right",
                  }}
                >
                  {""}
                </TableCell>
                <TableCell
                  className="reportTD"
                  colSpan={1}
                  style={{
                    background: "F5FAFE",
                    fontSize: fontVal,
                    fontWeight: "600",
                    textAlign: "left",
                  }}
                >
                  {item.totalCaption}
                </TableCell>
                <TableCell
                  className="reportTD"
                  colSpan={1}
                  style={{
                    background: "F5FAFE",
                    fontSize: fontVal,
                    fontWeight: "600",
                    textAlign: "right",
                  }}
                >
                  {item.Amount}
                </TableCell>
                <TableCell
                  className="reportTD"
                  colSpan={2}
                  style={{
                    background: "F5FAFE",
                    fontSize: fontVal,
                    fontWeight: "600",
                    textAlign: "right",
                  }}
                >
                  {""}
                </TableCell>
              </>
            </TableRow>
          )
        )}
      </>
    );
  };

  return (
    <>
      <Table style={{ display: "none" }}>
        <TableHead
          style={{
            position: `sticky`,
            top: `0`,
            zIndex: "3",
            display: "none",
          }}
        >
          <TableRow>
            <TableCell colSpan={13} style={{ fontSize: "16px" }}>
              KARNATAKA STATE ROAD TRANSPORT CORPORATION
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell colSpan={13} style={{ fontSize: "14px" }}>
              POS Transaction Report
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell
              colSpan={6}
              style={{ fontSize: "14px", textAlign: "left" }}
            >{`Date : ${moment(fromDate).format(
              "DD-MMM-YYYY"
            )} -To ${moment(toDate).format(
              "DD-MMM-YYYY"
            )} `}</TableCell>
            <TableCell
              colSpan={7}
              style={{ fontSize: "14px", textAlign: "right" }}
            >
              {" "}
              {`User: ${user?.UserName || ""} (${sessionStorage.getItem("LoginId") || ""
                })`}{" "}
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell
              colSpan={6}
              style={{ fontSize: "14px", textAlign: "right" }}
            >            {" "}</TableCell>
            <TableCell
              colSpan={7}
              style={{ fontSize: "14px", textAlign: "right" }}
            >{`Print Date & Time : ${moment(new Date()).format(
              "DD-MMM-YYYY HH:mm"
            )}`}</TableCell>
          </TableRow>
        </TableHead>
      </Table>
      <Box sx={{ padding: "10px 0px 10px 0px" }}>
        <TableContainer
          component={Paper}
          sx={{
            marginBottom: "30px",
            border: "1px solid #000000",
            overflow: "hidden",
            minWidth: "max-content",
          }}
        >
          <style>{`div#root {width: fit-content;}`}</style>
          <Table
            stickyHeader
            size="small"
            aria-label="a dense table"
            sx={{
              width: "100%",
              "& .MuiTableCell-root": {
                padding: "6px 8px !important",
              },
            }}
          >
            <TableHead style={{ position: `sticky`, top: `0`, zIndex: 2 }}>
              <TableRow>
                {TableHeaderColumn?.map((col, index) => (
                  <TableCell
                    key={`THR-${index}`}
                    colSpan={13}
                    sx={{
                      ...col.headerSx,
                      height: "29px",
                      color: "#000000",
                      fontSize: "12px",
                      fontWeight: "600",
                      lineHeight: "2px !important",
                      borderBottom: "1px solid #000000",
                      textAlign: 'left'
                    }}
                  >
                    {col.headerName}
                  </TableCell>
                ))}
              </TableRow>
              <TableRow>
                {TableHeaderColumnTwo?.map((col, index) => (
                  <TableCell
                    key={`THR-${index}`}
                    sx={{
                      ...col.headerSx,
                      height: "29px",
                      color: "#000000",
                      fontSize: "12px",
                      fontWeight: "600",
                      lineHeight: "2px !important",
                      borderBottom: "1px solid #000000",
                    }}
                  >
                    {col.headerName}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            {reportsData?.length < 1 ? (
              <>
                <TableBody>
                  <TableRow>
                    <TableCell colSpan={13}>
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          marginTop: "20px",
                          marginBottom: "20px",
                          color: "red",
                          fontSize: "12px",
                          lineheight: "16px",
                          letterspacing: "0.24px",
                        }}
                      >
                        <span>
                          No results found. Please refine your search parameters
                          and search again.
                        </span>
                      </div>
                    </TableCell>
                  </TableRow>
                </TableBody>
              </>
            ) : reportsData?.length >= 1 ? (
              <TableBody
                style={{
                  textAlign: "center",
                  fontSize: "12px",
                  lineheight: "16px",
                  letterspacing: "0.24px",
                  fontWeight: "500",
                  marginLeft: "5px",
                }}
              >
                {reportsData?.map((item, index) => (
                  <InsideRowContent
                    item={item}
                    index={index}
                    key={index}
                    fontVal={"12px"}
                  />
                ))}
              </TableBody>
            ) : (
              ""
            )}
          </Table>
        </TableContainer>
        <TableContainer
          component={Paper}
          sx={{
            marginBottom: "30px",
            border: "1px solid #000000",
            overflow: "hidden",
            minWidth: "max-content",
          }}
        >
          <Table
            stickyHeader
            size="small"
            aria-label="a dense table"
            sx={{
              width: "100%",
              "& .MuiTableCell-root": {
                padding: "6px 8px !important",
              },
            }}
          >
            <TableHead style={{ position: `sticky`, top: `0`, zIndex: 2 }}>
              <TableRow>
                {TableTwoHeaderColumn?.map((col, index) => (
                  <TableCell
                    key={`THR-${index}`}
                    colSpan={13}
                    sx={{
                      ...col.headerSx,
                      height: "29px",
                      color: "#000000",
                      fontSize: "12px",
                      fontWeight: "600",
                      lineHeight: "2px !important",
                      borderBottom: "1px solid #000000",
                      textAlign: 'left'
                    }}
                  >
                    {col.headerName}
                  </TableCell>
                ))}
              </TableRow>
              <TableRow>
                {TableHeaderColumnTwo?.map((col, index) => (
                  <TableCell
                    key={`THR-${index}`}
                    sx={{
                      ...col.headerSx,
                      height: "29px",
                      color: "#000000",
                      fontSize: "12px",
                      fontWeight: "600",
                      lineHeight: "2px !important",
                      borderBottom: "1px solid #000000",
                    }}
                  >
                    {col.headerName}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            {reportData1?.length < 1 ? (
              <>
                <TableBody>
                  <TableRow>
                    <TableCell colSpan={13}>
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          marginTop: "20px",
                          marginBottom: "20px",
                          color: "red",
                          fontSize: "12px",
                          lineheight: "16px",
                          letterspacing: "0.24px",
                        }}
                      >
                        <span>
                          No results found. Please refine your search parameters
                          and search again.
                        </span>
                      </div>
                    </TableCell>
                  </TableRow>
                </TableBody>
              </>
            ) : reportsData?.length >= 1 ? (
              <TableBody
                style={{
                  textAlign: "center",
                  fontSize: "12px",
                  lineheight: "16px",
                  letterspacing: "0.24px",
                  fontWeight: "500",
                  marginLeft: "5px",
                }}
              >
                {reportsData?.map((item, index) => (
                  <InsideRowContent
                    item={item}
                    index={index}
                    key={index}
                    fontVal={"12px"}
                  />
                ))}
              </TableBody>
            ) : (
              ""
            )}
          </Table>
        </TableContainer>
      </Box>
    </>
  );
};

export default ExcelTable;
